import { ChatProspectStage } from '@/types';
import { Icons } from '@usepepper/sprout-kit-ui';
import type { ColorTokens } from '@usepepper/sprout-kit-ui';

export interface ProspectStageVisual {
  color: ColorTokens;
  icon: typeof Icons.Circle;
  isHollow: boolean;
}

export interface ProspectStageIconOutline {
  color: ColorTokens;
  opacity: number;
}

export const PROSPECT_STAGE_ICON_OUTLINE: ProspectStageIconOutline = {
  color: '$gray12',
  opacity: 0.25,
};

const DEFAULT_PROSPECT_STAGE_VISUAL: ProspectStageVisual = {
  color: '$gray6',
  icon: Icons.Square,
  isHollow: false,
};

const PROSPECT_STAGE_VISUALS: Partial<
  Record<ChatProspectStage, ProspectStageVisual>
> = {
  [ChatProspectStage.Cold]: {
    color: '$gray6',
    icon: Icons.Circle,
    isHollow: true,
  },
  [ChatProspectStage.Discovery]: {
    color: '$blue5',
    icon: Icons.Diamond,
    isHollow: false,
  },
  [ChatProspectStage.Engaged]: {
    color: '$blue7',
    icon: Icons.Square,
    isHollow: false,
  },
  [ChatProspectStage.Quote]: {
    color: '$blue9',
    icon: Icons.Triangle,
    isHollow: false,
  },
  [ChatProspectStage.Won]: {
    color: '$blue11',
    icon: Icons.Circle,
    isHollow: false,
  },
};

export const getProspectStageVisual = (
  stage: ChatProspectStage,
): ProspectStageVisual =>
  PROSPECT_STAGE_VISUALS[stage] ?? DEFAULT_PROSPECT_STAGE_VISUAL;
